import { Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractPlugin } from './abstract-plugin.component';

export class Plugin extends AbstractPlugin implements OnInit, OnDestroy {

    /**
     * The heading ViewContainerRef instance.
     */
    @ViewChild('header') header: TemplateRef<any>;

    /**
     * The body ViewContainerRef instance.
     */
    @ViewChild('body') body: TemplateRef<any>;

    /**
     * The footer ViewContainerRef instance.
     */
    @ViewChild('footer') footer: TemplateRef<any>;

    /**
     * The modals data.
     */
    @Input() protected data: { [key: string]: any };

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/plugin.component.ts